import { useMemo } from "react";
import {
  LastMessageFragment,
  MessageFragment,
  MessageThreadFragment,
} from "gql/graphql";
import useMessageThreadTranslation from "./use-message-thread-translation";
import { isEmpty } from "lodash";

const useMessageText = (
  message: MessageFragment | LastMessageFragment,
  messageThread?: MessageThreadFragment,
) => {
  const { isViewingTranslatedMessage } = useMessageThreadTranslation(
    message,
    messageThread,
  );

  const messageHasContent = message.text !== null && !isEmpty(message.text);
  const renderedText = useMemo(() => {
    if (
      isViewingTranslatedMessage &&
      !!messageThread?.locale &&
      message.localizedText !== null
    ) {
      return message.localizedText;
    }
    if (!!message.text && message.text.length > 0) {
      return message.text;
    }
    if (!!message.actionText && message.actionText.length > 0) {
      return message.actionText;
    }
  }, [
    isViewingTranslatedMessage,
    message.actionText,
    message.localizedText,
    message.text,
    messageThread?.locale,
  ]);

  return {
    renderedText,
    messageHasContent,
  };
};

export default useMessageText;
